export enum ErrorType {
  Unexpected = 100,
  AnotherAccountGlobo = "101",
  ErrProviderWithoutResources = "102",
  UserWithoutPackage = "103",
  InvalidCredentials = "104",
  ProviderGenericError = "105",
  ProviderContentNotIncluded = "106"
}
